<template>
  <footer class="residentportal-footer page-footer font-small blue">
    <div class="container">
      <div class="footer-resident py-3">
        <div class="row no-gutters">
          <div class="col-xs-12 col-md-3">
            <p class="pt-2 mb-md-0 mb-xs-3 council-name">{{footerSettings.councilName}}</p>
          </div>
          <div class="col-xs-12 col-md-9">
            <ul class="residentportal-footer__list">
                <li v-if="footerSettings.email">
                  <a :href="'mailto:' + footerSettings.email" class="contact-link">
                    <span
                      class="icon icon-email"
                      :style="{'color': isMaroondah ? 'white' : MainUISettings.main_site_button_color}"
                      aria-label="Email"></span> 
                    <span class="text-wrap text-break">{{footerSettings.email}}</span></a>
                </li>
                <li v-if="footerSettings.contactNumber">
                  <a :href="'tel:' + footerSettings.contactNumber" class="contact-link">
                    <span
                      class="icon icon-phone"
                      :style="{'color': isMaroondah ? 'white' : MainUISettings.main_site_button_color}"
                      aria-label="Contact Number"></span> 
                    <span class="text-wrap text-break">{{footerSettings.contactNumber}}</span>
                    </a>
                </li>
                <li v-if="footerSettings.operatingHours">
                  <div tabindex="0">
                    <span
                      class="icon icon-timeline"
                      :style="{'color': isMaroondah ? 'white' : MainUISettings.main_site_button_color}"
                      aria-label="Operating hours"></span> 
                    <span class="text-wrap text-break">{{footerSettings.operatingHours}}</span>
                  </div>
                </li>
              </ul>
          </div>
        </div>
      </div>
      <div class="footer-copyright" v-if="footerSettings.isSecondFooter == 1">
        <div class="row no-gutters">
          <div class="col-xs-12 col-md-5 col-xl-4 pt-2 d-sm-block">
            <a href="#" class="residentportal-footer__logo mb-3 mb-md-0">
              <img 
                :src="pubPath+footerSettings.logoPath"
                v-if="footerSettings.logoPath"
                :alt="footerSettings.logoPathAttribute.alt" 
                :title="footerSettings.logoPathAttribute.title"
              />
            </a>
            <br>
            <span class="footer-copyright__title ml-0">{{ footerSettings.copyrightText }}</span>
          </div>
          <div class="col-xs-12 col-md-7 col-xl-8">
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <ul class="residentportal-footer__list">
                  <li v-for="footer_link in footerSettings.footer_links.filter(l => l.text && l.url)" :key="footer_link.footer_link_id">
                    <a class="residentportal-footer__link" :href="footer_link.url">{{ footer_link.text }}</a>
                  </li>
                </ul>
              </div>
              <!-- google translate here -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import Helper from '../../helper';
  export default {
    data() {
      return {
        pubPath: process.env.MIX_APP_URL,
        isMaroondah: Helper.getPortalName() == 'maroondah'
      }
    },
    computed: {
      footerSettings() {
        return this.$store.getters['GET_FOOTER_SETTINGS']; 
      },
      MainUISettings() {
        return this.$store.getters['GET_MAIN_UI']; 
      }
    },
    mounted() {
      this.$store.dispatch('footerSettings');
      // this.$store.dispatch('mainUI');
    }
  }
</script>